import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faHome from '@fortawesome/fontawesome-free-solid/faHome';
import faArrowAltCircleLeft from '@fortawesome/fontawesome-free-solid/faArrowAltCircleLeft';
import faSignOutAlt from '@fortawesome/fontawesome-free-solid/faSignOutAlt';
import * as authActions from '../../actions/authActions';
import { toast } from 'react-toastify';
import { hasRole } from '../../services/authService';

class DashNav extends Component {
  logOut = () => {
    this.props.actions.logOut().then(() => {
      toast.success('Successfully logged out user');
    });
    this.props.history.push('/login');
  };

  goBack = () => {
    this.props.history.goBack();
  };

  goToDashboard = () => {
    this.props.history.push('/dashboard');
  };

  render() {
    return (
      <div>
        {hasRole('ROLE_EMPLOYEE') && (
          <Container fluid={true} className="db-nav">
            <Row>
              <Col sm={12} className="text-right my-2">
                <FontAwesomeIcon
                  onClick={this.goBack}
                  icon={faArrowAltCircleLeft}
                  size="2x"
                  className="mr-2"
                />
                <FontAwesomeIcon
                  onClick={this.goToDashboard}
                  icon={faHome}
                  size="2x"
                  className="mr-2"
                />
                <FontAwesomeIcon
                  onClick={this.logOut}
                  icon={faSignOutAlt}
                  size="2x"
                />
              </Col>
            </Row>
          </Container>
        )}
      </div>
    );
  }
}

DashNav.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(authActions, dispatch),
  };
}

export default withRouter(connect(null, mapDispatchToProps)(DashNav));



// WEBPACK FOOTER //
// ./src/components/common/DashNav.js